import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Equipment from "./pages/Equipment";
import Maintenance from "./pages/Maintenance";
import ScheduledMaintenance from "./pages/ScheduledMaintenance";
import WaterMonitoring from "./pages/WaterMonitoring";
import WaterMeters from "./pages/WaterMeters";
import SolarReadings from "./pages/SolarReadings";
import ChristmasWorks from "./pages/ChristmasWorks";
import SummerWorks from "./pages/SummerWorks";
import UTASchedules from "./pages/UTASchedules";
import Alerts from "./pages/Alerts";
import VideoInstructions from "./pages/VideoInstructions";
import Users from "./pages/Users";
import Layout from "./components/Layout";
import { Toaster } from "./components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const axiosInstance = axios.create({
  baseURL: API,
});

// Add auth token to requests
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await axiosInstance.get('/auth/me');
        setUser(response.data);
      } catch (error) {
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  };

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    // Forza il redirect alla pagina di login
    window.location.href = '/login';
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-50 to-blue-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={!user ? <Login onLogin={handleLogin} /> : <Navigate to={user?.role === 'water_monitor' ? '/water-monitoring' : '/'} />}
          />
          <Route
            path="/"
            element={user ? <Layout user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          >
            <Route index element={user?.role === 'water_monitor' ? <Navigate to="/water-monitoring" /> : <Dashboard user={user} />} />
            <Route path="equipment" element={<Equipment user={user} />} />
            <Route path="maintenance" element={<Maintenance user={user} />} />
            <Route path="scheduled" element={<ScheduledMaintenance user={user} />} />
            <Route path="water-monitoring" element={<WaterMonitoring user={user} />} />
            <Route path="water-meters" element={<WaterMeters user={user} />} />
            <Route path="solar-readings" element={<SolarReadings user={user} />} />
            <Route path="christmas-works" element={<ChristmasWorks user={user} />} />
            <Route path="summer-works" element={<SummerWorks user={user} />} />
            <Route path="uta-schedules" element={<UTASchedules user={user} />} />
            <Route path="alerts" element={<Alerts user={user} />} />
            <Route path="video-instructions" element={<VideoInstructions user={user} />} />
            {user?.role === 'admin' && <Route path="users" element={<Users user={user} />} />}
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;